import { Type } from 'class-transformer';
import { ArrayMaxSize, ArrayMinSize, IsArray, ValidateNested } from 'class-validator';

import { MAX_BULK_DRAFT_ORDERS } from './draft-bulk.constants';
import { SubmitDraftItemDto } from './submit-draft-item.dto';

export class SubmitDraftsBulkDto {
  /**
   * Array of draft payloads to submit as orders in a single request. Min 1 Max 200.
   */
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(MAX_BULK_DRAFT_ORDERS)
  @ValidateNested({ each: true })
  @Type(() => SubmitDraftItemDto)
  public drafts: SubmitDraftItemDto[];
}
